import { Component } from '@angular/core';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { FooterComponentLayout } from '../../../../shared/components/footer/footer.component';
import { MainComponent } from '../../components/main/main.component';
import { ImpersonationHeaderComponent } from '../../../../shared/components/impersonation-header/impersonation-header.component';

@Component({
    selector: 'app-landing-page',
    imports: [HeaderComponent, FooterComponentLayout, MainComponent, ImpersonationHeaderComponent],
    templateUrl: './landing-page.component.html',
    styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent {
  userName!: string;
  impersonatedUser!: string;

  constructor(){}

  ngOnInit(): void {
    this.impersonatedUser = localStorage.getItem("impersonatedUser") ?? ""
    this.userName = localStorage.getItem("userName") ?? ""
    localStorage.setItem("isLoggedin","true")
 }

}
